import { gql } from '@apollo/client';

export const CREATE_CONSOLE_ACTION_PAYLOAD = gql`
  mutation s1CreateConsoleAction($console: String!, $context: String!) {
    s1CreateConsoleAction(managementConsoleUrl: $console, actionContext: $context)
  }
`;

export const APPLY_CONSOLE_ACTION = gql`
  mutation s1PerformGenericAgentAction($console: String!, $actionPath: String!, $data: String!, $filter: String!) {
    s1PerformGenericAgentAction(managementConsoleUrl: $console, actionPath: $actionPath, data: $data, filter: $filter) {
      data {
        affected
      }
    }
  }
`;
